import ConfirmationModal from 'components/ui/modals/confirmation/ConfirmationModal'
import { useTranslation } from 'react-i18next'

interface DeleteManyProps {
  show: boolean
  count: number
  onAccept(): void
  onClose(): void
}

export const DeleteMany = ({
  show,
  count,
  onAccept,
  onClose,
}: DeleteManyProps) => {
  const { t } = useTranslation()
  const key = `administration.modal.externalCourseParticipantsDeleteConfirmation`
  return (
    <ConfirmationModal
      show={show}
      title=""
      text={t(key, {
        count,
      })}
      acceptButtonText={t('components.modal.buttons.delete')}
      onAccept={() => onAccept()}
      onClose={() => onClose()}
    />
  )
}
